import React, { useEffect } from 'react';
import Wrapper from './styles';
import { useCartContext } from '../../context/cart_context';
import { useLanguageContext } from '../../context/language_context';
import { Link } from 'react-router-dom';
import { CartContent, PageHero } from '../../components';

const CartPage = () => {
  const { cart } = useCartContext();
  const { t, isArabic } = useLanguageContext();

  useEffect(() => {
    document.title = 'Art & Bois | Cart';
  }, []);

  if (cart.length < 1) {
    return (
      <Wrapper className='page-100' style={{ direction: isArabic ? 'rtl' : 'ltr' }}>
        <div className='empty'>
          <h2>{t.cart.empty}</h2>
          <Link to='/products' className='btn'>
            {t.cart.fillCart}
          </Link>
        </div>
      </Wrapper>
    );
  }

  return (
    <main style={{ direction: isArabic ? 'rtl' : 'ltr' }}>
      <PageHero title={t.nav.cart} />
      <Wrapper className='page'>
        <CartContent />
      </Wrapper>
    </main>
  );
};

export default CartPage;
